/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Leader_ClicksInputs */

const en_directory_vibebids_leader_clicks = /** @type {(inputs: Directory_Vibebids_Leader_ClicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leader clicks`)
};

const zh_directory_vibebids_leader_clicks = /** @type {(inputs: Directory_Vibebids_Leader_ClicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领先产品点击`)
};

/**
* | output |
* | --- |
* | "leader clicks" |
*
* @param {Directory_Vibebids_Leader_ClicksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_leader_clicks = /** @type {((inputs?: Directory_Vibebids_Leader_ClicksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Leader_ClicksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_leader_clicks(inputs)
	return zh_directory_vibebids_leader_clicks(inputs)
});
export { directory_vibebids_leader_clicks as "directory.vibebids.leader_clicks" }